module.exports = __webpack_public_path__ + "static/media/loading.27242eea.gif";